import React from "react"
import { connect } from "react-redux"
import RecommendedEpisodes from "../../../design/LastPage/RecommendedEpisodes"
import { episodePath, isLogged, isCurrentEpisodeLocked } from "../../helpers"

const mapState = (state, ownProps) => {
  const currentEpisodeIndex =
    state.episodes.findIndex((e) => e.id === state.currentEpisode.id) + 1
  const episodes = state.episodes.map((ep) => ({
    img: ep.thumbnail_url,
    title: ep.title,
    pageCount: I18n.t(
      "components.episode_last_page.recommended_episodes.pages",
      { count: ep.pages_count }
    ),
    likesCount: ep.public_stats.likes_count,
    commentCount: ep.public_stats.pop_comments_count,
    premium: ep.premium,
    price: ep.price,
    paid: ep.paid,
    published_on: ep.published_on,
    unlockedText: I18n.t("common.paid"),
    freeText: I18n.t("common.free"),
    onClick: () => {
      window.location.href = episodePath(state.story.slug, ep.slug)
    },
    isNovel: state.story.publication_type === "novel"
  }))
  const lockedPremiumContent = isCurrentEpisodeLocked(state)

  return {
    episodes,
    currentEpisode: !lockedPremiumContent ? currentEpisodeIndex : -1,
    title: !lockedPremiumContent ? ownProps.t.title : ownProps.t.titleLocked,
    subtitle: !lockedPremiumContent ? ownProps.t.subtitle : "",
    upNext: ownProps.t.up_next
  }
}

export default connect(mapState)(RecommendedEpisodes)
